import { jsxs as f, jsx as o } from "react/jsx-runtime";
import { forwardRef as h, useMemo as u } from "react";
import { useMultiStyleConfig as y, VStack as C, HStack as N, Divider as k } from "@chakra-ui/react";
import { useStepsContext as I } from "./useStepsContext.mjs";
import { StepIcon as V } from "./StepIcon.mjs";
import { StepLabel as _ } from "./StepLabel.mjs";
import { getStepVariant as w, getAriaFriendlyVariant as L } from "./stepsFunctions.mjs";
import { combineClasses as M } from "../../../utils/combineClasses.mjs";
const j = h((D, v) => {
  const { children: p, className: b, isDisabled: s = !1, stepNumber: t = 0, variant: l, ...x } = D, {
    stepsState: a,
    handleStepSelection: c,
    isStepSelectDisabled: i,
    internalId: $,
    dataTestId: d,
    componentClassPrefix: m
  } = I(), r = u(
    () => l || w(t, a.activeStep),
    [l, t, a.activeStep]
  ), n = y("Steps", { variant: r }), S = u(
    () => a.totalSteps === t,
    [a.totalSteps, t]
  ), g = M(`${m}__step`, b);
  return /* @__PURE__ */ f(
    C,
    {
      ref: v,
      role: "option",
      id: `${$}-details-${t}`,
      "data-testid": d && `${d}-details-${t}`,
      className: g,
      sx: n.stepDetails,
      align: "stretch",
      spacing: 1,
      onMouseDown: (e) => e.preventDefault(),
      onClick: (e) => {
        e.preventDefault(), c(e, i || s, t);
      },
      onKeyDown: (e) => {
        e.key === "Enter" && (e.preventDefault(), c(e, i || s, t));
      },
      ...S && { "data-last": !0 },
      ...t === 1 && { "data-first": !0 },
      ...i && { "data-no-click": !0 },
      ...(s || i) && { "aria-disabled": !0 },
      "aria-selected": !s && a.activeStep === t,
      "aria-label": `Step ${t} - ${p}` + (r !== "default" ? ` - ${L(r)}.` : "."),
      tabIndex: -1,
      ...x,
      children: [
        /* @__PURE__ */ f(
          N,
          {
            spacing: 2,
            sx: n.stepDetailsLabel,
            className: `${m}__step-details`,
            children: [
              /* @__PURE__ */ o(V, { step: t, stepState: r }),
              /* @__PURE__ */ o(_, { children: p })
            ]
          }
        ),
        !S && /* @__PURE__ */ o(k, { sx: n.verticalDivider, "aria-hidden": !0 })
      ]
    }
  );
});
j.displayName = "StepDetails";
export {
  j as StepDetails
};
